<!-- <div id="mapa" class="map col-sm-12 col-md-12">
    <div id="map"></div>
</div> -->

<div id="map" #map></div>